/* PDP Imunofem, baseada no layout do Sérum: galeria, kits, adicionais,
   cabeçalho e compra com abertura do carrinho. */
(function () {
  var root = document.querySelector('[data-cl2]');
  if (!root) return;
  if (root.__maxfemPdpReady) return;
  root.__maxfemPdpReady = true;

  var PARC = 1.22676 / 12;    /* fator da casa para 12x no cartão */

  /* ── header próprio: vai para o início do body (assim gruda no topo da página inteira) ── */
  var hdr = document.querySelector('[data-cl2h]');
  if (hdr) {
    if (hdr.parentElement !== document.body) document.body.insertBefore(hdr, document.body.firstChild);
    var hBar = hdr.querySelector('[data-cl2h-bar]');
    var hStuck = function () { hBar.classList.toggle('is-stuck', window.scrollY > 40); };
    window.addEventListener('scroll', hStuck, { passive: true });
    hStuck();

    var drawer = hdr.querySelector('[data-cl2h-drawer]');
    var hOpen = hdr.querySelector('[data-cl2h-open]');
    var openDrawer = function () {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      hOpen.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var x = drawer.querySelector('[data-cl2h-close]');
      if (x) x.focus({ preventScroll: true });
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      hOpen.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 260);
      hOpen.focus({ preventScroll: true });
    };
    hOpen.addEventListener('click', openDrawer);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-cl2h-close]')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });

    /* carrinho: abre a gaveta do app (Section Store) quando ela existe; senão segue para /cart */
    var hCart = hdr.querySelector('[data-cl2h-cart]');
    hCart.addEventListener('click', function (e) {
      if (window.SectionStoreCart && typeof window.SectionStoreCart.open === 'function') {
        e.preventDefault();
        e.stopPropagation();
        window.SectionStoreCart.open();
      }
    });
    var hCount = hdr.querySelector('[data-cl2h-count]');
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        hCount.textContent = c.item_count;
        hCount.hidden = !c.item_count;
        hCart.setAttribute('aria-label', 'Carrinho, ' + c.item_count + ' itens');
      })
      .catch(function () {});
  }

  var purchaseFlow = {
    labels: { adding: 'Adicionando…', error: 'Não foi possível adicionar. Tente novamente.' },
    finishPurchase: async function () {
      var api = window.MxCart || window.SectionStoreCart;
      if (!api) {
        api = await new Promise(function (resolve) {
          var started = Date.now();
          var timer = setInterval(function () {
            var ready = window.MxCart || window.SectionStoreCart;
            if (ready || Date.now() - started > 4000) { clearInterval(timer); resolve(ready); }
          }, 100);
        });
      }
      if (api && typeof api.open === 'function') {
        if (typeof api.refresh === 'function') await Promise.resolve(api.refresh()).catch(function () {});
        api.open();
      } else {
        window.location.href = (window.Shopify.routes.root || '/') + 'cart';
      }
    }
  };

  function money(c) {
    var v = (Math.round(c) / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function setAll(sel, txt) {
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
  }

  /* ── kit + adicionais ── */
  var kits = [].slice.call(root.querySelectorAll('.cl2-kit input'));
  var adds = [].slice.call(root.querySelectorAll('.cl2-addc input'));

  function currentKit() {
    var k = kits.filter(function (i) { return i.checked; })[0];
    if (!k) {
      k = kits.filter(function (i) { return !i.disabled; })[0];
      if (k) k.checked = true;
    }
    return k;
  }

  function update() {
    var k = currentKit();
    if (!k) return;
    kits.forEach(function (i) { i.closest('.cl2-kit').classList.toggle('is-on', i.checked); });
    adds.forEach(function (i) { i.closest('.cl2-addc').classList.toggle('is-on', i.checked); });

    var kp = +k.dataset.price, kc = +k.dataset.compare || kp;
    var tot = kp, was = kc;
    adds.forEach(function (i) {
      if (!i.checked) return;
      tot += +i.dataset.price;
      was += (+i.dataset.compare || +i.dataset.price);
    });
    var eco = Math.max(0, was - tot);

    /* topo = preço do kit escolhido; total, economia e barra fixa = kit + adicionais */
    setAll('[data-cl2-parc]', money(kp * PARC));
    setAll('[data-cl2-full]', money(kp));
    setAll('[data-cl2-off]', kc > kp ? Math.round((kc - kp) * 100 / kc) + '% OFF' : '');
    setAll('[data-cl2-s-parc]', money(tot * PARC));
    setAll('[data-cl2-s-full],[data-cl2-total]', money(tot));
    root.querySelectorAll('[data-cl2-frete]').forEach(function (el) { el.hidden = tot < 19900; });
    setAll('[data-cl2-was],[data-cl2-s-was]', eco > 0 ? money(was) : '');
    setAll('[data-cl2-eco]', money(eco));
    setAll('[data-cl2-ecop]', was > 0 ? Math.round(eco * 100 / was) : 0);
    var save = root.querySelector('[data-cl2-save]');
    if (save) save.style.display = eco > 0 ? '' : 'none';
  }
  kits.concat(adds).forEach(function (i) { i.addEventListener('change', update); });
  update();

  /* ── compra: carrinho (dispara os eventos de add to cart) e checkout ── */
  function limparCupom() {
    var host = location.hostname.replace(/^www\./, '');
    ['', '; domain=' + host, '; domain=.' + host].forEach(function (d) {
      document.cookie = 'discount_code=; Max-Age=0; path=/' + d;
    });
  }
  /* cupons que esta página gerencia: os dos kits por quantidade (data-cupom do rádio) */
  var cupomKits = kits.map(function (i) { return (i.dataset.cupom || '').trim().toUpperCase(); })
    .filter(function (c) { return c; });

  var buying = false;
  function buy(btn) {
    if (buying) return;
    var k = currentKit();
    if (!k) return;
    /* data-cart-qty: só o kit por quantidade manda mais de 1 frasco. No modo variante o data-qty
       é o número de meses do título e não pode virar quantidade no carrinho. */
    var items = [{ id: +k.value, quantity: +k.dataset.cartQty || 1 }];
    adds.forEach(function (i) { if (i.checked) items.push({ id: +i.value, quantity: 1 }); });
    /* adicionais com desconto: PREFIXO-N (N = quantos adicionais), prefixo vem da seção (data-cupom) */
    var prefixo = (root.dataset.cupom || '').trim();
    var limpar = root.dataset.limpar === '1';
    var cupom = prefixo && items.length > 1 ? prefixo + '-' + (items.length - 1) : '';
    /* kit por quantidade: o preço do kit é um cupom de pedido, que soma com o dos adicionais */
    var codigos = [(k.dataset.cupom || '').trim(), cupom].filter(function (c) { return c; });

    buying = true;
    var purchaseMessage = root.querySelector('[data-cl2-msg]');
    if (purchaseMessage) purchaseMessage.textContent = '';
    root.querySelectorAll('[data-cl2-buy]').forEach(function (b) { b.disabled = true; });
    var label = btn.textContent;
    btn.textContent = purchaseFlow.labels.adding;

    /* os cupons entram ANTES do add: a gaveta do app abre sozinha quando o item cai no carrinho,
       e sem o cupom já aplicado ela aparece com o preço cheio até o update chegar */
    var setCodes = function (lista) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: lista })
      });
    };
    var cuponsAntes = null;   /* o que já estava no carrinho, para desfazer se o add falhar */
    function aplicarCupons() {
      /* limpar ligado: o checkout sai só com os cupons desta compra (troca o código do carrinho e apaga
         o cookie discount_code que um link /discount/CODIGO ou ?discount= deixa gravado) */
      if (limpar) {
        limparCupom();
        cuponsAntes = '';
        return setCodes(codigos.join(',')).catch(function () {});
      }
      if (!codigos.length && !cupomKits.length && !prefixo) return Promise.resolve();
      /* limpar desligado: mantém os cupons de fora e troca só os desta página (um kit ou um
         adicional desmarcado tem que tirar o cupom da escolha anterior) */
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var pre = prefixo ? prefixo.toUpperCase() + '-' : '';
          var todos = (c.discount_codes || []).map(function (d) { return d.code; })
            .filter(function (code) { return code; });
          cuponsAntes = todos.join(',');
          var lista = todos.filter(function (code) {
            var up = code.toUpperCase();
            if (pre && up.indexOf(pre) === 0) return false;
            return cupomKits.indexOf(up) === -1;
          });
          codigos.forEach(function (code) { lista.push(code); });
          return setCodes(lista.join(','));
        }).catch(function () {});
    }

    aplicarCupons().then(function () {
      /* _section_store_cart=1: sem a marca o app do carrinho abre a gaveta por cima */
      return fetch('/cart/add.js?_section_store_cart=1', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      if (limpar) limparCupom();
      return purchaseFlow.finishPurchase();
    }).catch(function () {
      if (limpar) limparCupom();
      /* add falhou: volta os cupons de antes, senão o do kit ficaria valendo sem o produto no carrinho */
      if (cuponsAntes !== null) setCodes(cuponsAntes).catch(function () {});
      {
        var message = root.querySelector('[data-cl2-msg]');
        if (message) message.textContent = purchaseFlow.labels.error;
      }
    }).finally(resetBuy);

    /* Re-enable only after the request finishes to prevent duplicate additions. */
    function resetBuy() {
      buying = false;
      btn.textContent = label;
      root.querySelectorAll('[data-cl2-buy]').forEach(function (b) { b.disabled = false; });
      /* o carrinho já podia ter frascos antes desta compra: o kit vale pela quantidade somada */
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(sincronizarKit).catch(function () {});
    }
  }
  root.querySelectorAll('[data-cl2-buy]').forEach(function (b) {
    b.addEventListener('click', function () { buy(b); });
  });

  /* ── kit por quantidade x +/− da gaveta: mudar a quantidade no carrinho não trocava o cupom do kit
     (2 frascos com cheiro2 viravam 3 a R$ 189,00 e não R$ 170,00; tirar o produto deixava o cupom de
     pedido valendo para o resto). O cupom passa a ser o do maior kit que cabe na quantidade do frasco
     no carrinho; abaixo do menor kit ele sai. Cupons de fora ficam. ── */
  var kitsQtd = kits.map(function (i) {
    return { qtd: +i.dataset.cartQty || 0, cupom: (i.dataset.cupom || '').trim() };
  }).filter(function (x) { return x.qtd > 1 && x.cupom; })
    .sort(function (a, b) { return b.qtd - a.qtd; });
  var kitVariantes = kits.map(function (i) { return String(i.value); });
  var sincronizando = false;
  function sincronizarKit(c) {
    if (!kitsQtd.length || buying || sincronizando || !c || !c.items) return;
    var qtd = c.items.reduce(function (n, it) {
      var p = it.properties || {};
      var brinde = p._gift != null || p._mx_reward_gift != null || p._free_gift != null || p.__gift != null;
      return kitVariantes.indexOf(String(it.variant_id)) !== -1 && !brinde ? n + it.quantity : n;
    }, 0);
    var alvo = '';
    for (var i = 0; i < kitsQtd.length; i++) { if (kitsQtd[i].qtd <= qtd) { alvo = kitsQtd[i].cupom; break; } }
    var doKit = kitsQtd.map(function (x) { return x.cupom.toUpperCase(); });
    var atuais = (c.discount_codes || []).map(function (d) { return d.code; }).filter(function (code) { return code; });
    var presentes = atuais.filter(function (code) { return doKit.indexOf(code.toUpperCase()) !== -1; });
    if (alvo ? presentes.length === 1 && presentes[0].toUpperCase() === alvo.toUpperCase() : !presentes.length) return;
    var lista = atuais.filter(function (code) { return doKit.indexOf(code.toUpperCase()) === -1; });
    if (alvo) lista.push(alvo);
    sincronizando = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: lista.join(',') })
    }).then(function () {
      if (window.MxCart && window.MxCart.refresh) return window.MxCart.refresh();
    }).catch(function () {}).then(function () { sincronizando = false; });
  }
  document.addEventListener('mx-cart:updated', function (e) { sincronizarKit(e.detail); });

  /* ── descrição do cadastro: "Modo de uso:" vira subtítulo; texto longo fica recolhido com "Ler mais" ── */
  root.querySelectorAll('[data-cl2-desc]').forEach(function (rte) {
    rte.querySelectorAll('p').forEach(function (p) {
      var t = p.textContent.replace(/\s+/g, ' ').trim();
      if (t.length > 1 && t.length <= 45 && /:$/.test(t) && !p.querySelector('img')) p.classList.add('cl2-desc__sub');
    });
    if (rte.scrollHeight > 420) {
      rte.classList.add('is-clamp');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'cl2-desc__more';
      more.textContent = 'Ler descrição completa';
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', function () {
        var aberto = rte.classList.toggle('is-clamp') === false;
        more.textContent = aberto ? 'Mostrar menos' : 'Ler descrição completa';
        more.setAttribute('aria-expanded', aberto ? 'true' : 'false');
        if (!aberto) rte.scrollIntoView({ block: 'nearest' });
      });
      rte.insertAdjacentElement('afterend', more);
    }
  });

  /* ── galeria no computador: gruda ao lado da compra; se for mais alta que a tela, gruda pelo pé ── */
  var galCol = root.querySelector('.cl2-gal');
  var galDesk = window.matchMedia('(min-width: 990px)');
  if (galCol) {
    /* miniatura clicada vira a foto principal (no celular a galeria é carrossel e o clique amplia) */
    var galTrack = galCol.querySelector('.cl2-gal__track');
    if (galTrack) galTrack.addEventListener('click', function (e) {
      if (!galDesk.matches) return;
      var fig = e.target.closest && e.target.closest('.cl2-gal__item');
      if (!fig || fig === galTrack.firstElementChild) return;
      e.preventDefault();
      e.stopPropagation();
      galTrack.insertBefore(fig, galTrack.firstElementChild);
    }, true);
    var galTop = function () {
      var t = Math.min(84, window.innerHeight - galCol.offsetHeight - 16);
      galCol.style.setProperty('--cl2-gal-top', t + 'px');
    };
    galTop();
    window.addEventListener('resize', galTop);
    window.addEventListener('load', galTop);
    galCol.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', galTop); });
  }

  /* ── barra fixa: aparece quando a área de compra sai da tela (acima ou abaixo) ── */
  var sticky = root.querySelector('[data-cl2-sticky]');
  var offer = root.querySelector('.cl2-offer');
  if (sticky && offer) {
    var stBtn = sticky.querySelector('button'), stOn = null, stRaf;
    var checkSticky = function () {
      var r = offer.getBoundingClientRect();
      var show = r.bottom < 0 || (r.top > window.innerHeight && window.scrollY > 200);
      if (show === stOn) return;
      stOn = show;
      sticky.classList.toggle('is-on', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      stBtn.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('cl2-bar-on', show);
    };
    window.addEventListener('scroll', function () {
      cancelAnimationFrame(stRaf);
      stRaf = requestAnimationFrame(checkSticky);
    }, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
  }

  /* ── carrosséis com pontos (galeria no celular, ensaio) ── */
  document.querySelectorAll('.cl2 [data-cl2-slider]').forEach(function (track) {
    var dots = track.parentElement.querySelector('[data-cl2-dots]');
    var items = track.children;
    if (!dots || items.length < 2) { if (dots) dots.style.display = 'none'; return; }
    for (var i = 0; i < items.length; i++) {
      var d = document.createElement('span');
      d.className = 'cl2-dot' + (i === 0 ? ' is-on' : '');
      dots.appendChild(d);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = items[0].getBoundingClientRect().width || 1;
        var idx = Math.round(track.scrollLeft / (w + 10));
        [].forEach.call(dots.children, function (d, j) { d.classList.toggle('is-on', j === idx); });
      });
    }, { passive: true });
  });

  /* ── stories: vídeo em tela cheia ── */
  var modal = root.querySelector('[data-cl2-modal]');
  var video = modal && modal.querySelector('[data-cl2-video]');
  function closeModal() {
    if (!modal) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }
  root.querySelectorAll('[data-cl2-story]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!modal) return;
      video.poster = b.dataset.poster || '';
      video.src = b.dataset.cl2Story;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  });
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-cl2-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
  }

  /* ── avaliações: filtro por região + "ver mais" ── */
  var revGrid = root.querySelector('[data-cl2-revs]');
  if (revGrid) {
    var revCards = [].slice.call(revGrid.children);
    var revMore = root.querySelector('[data-cl2-revmore]');
    var STEP = +revGrid.dataset.limite || 6;
    var revFilter = 'todas', revLimit = STEP;
    var renderRevs = function () {
      var match = revCards.filter(function (c) {
        return revFilter === 'todas' || (' ' + c.dataset.r + ' ').indexOf(' ' + revFilter + ' ') > -1;
      });
      revCards.forEach(function (c) { c.hidden = true; });
      match.forEach(function (c, i) { c.hidden = i >= revLimit; });
      if (revMore) revMore.hidden = match.length <= revLimit;
    };
    root.querySelectorAll('[data-cl2-rf]').forEach(function (b) {
      b.addEventListener('click', function () {
        revFilter = b.dataset.cl2Rf;
        revLimit = STEP;
        root.querySelectorAll('[data-cl2-rf]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        renderRevs();
      });
    });
    if (revMore) revMore.addEventListener('click', function () { revLimit += STEP; renderRevs(); });
    renderRevs();
  }

  /* ── imagens ampliáveis: galeria do topo (com navegação) e fotos das avaliações ── */
  var lb = root.querySelector('[data-cl2-lb]');
  if (lb) {
    var lbImg = lb.querySelector('[data-cl2-lbimg]');
    var lbPrev = lb.querySelector('[data-cl2-lbprev]');
    var lbNext = lb.querySelector('[data-cl2-lbnext]');
    var lbCount = lb.querySelector('[data-cl2-lbcount]');
    var lbList = [], lbIdx = 0, lbBack = null;
    var showLb = function () {
      var b = lbList[lbIdx];
      lbImg.src = b.dataset.cl2Img;
      var inner = b.querySelector('img');
      lbImg.alt = inner ? inner.alt : '';
      var many = lbList.length > 1;
      lbPrev.hidden = lbNext.hidden = lbCount.hidden = !many;
      if (many) lbCount.textContent = (lbIdx + 1) + ' / ' + lbList.length;
    };
    var openLb = function (b) {
      var g = b.dataset.cl2Group;
      lbList = g ? [].slice.call(document.querySelectorAll('.cl2 [data-cl2-img][data-cl2-group="' + g + '"]')) : [b];
      lbIdx = Math.max(0, lbList.indexOf(b));
      lbBack = b;
      showLb();
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      lb.querySelector('[data-cl2-lbclose]').focus({ preventScroll: true });
    };
    var closeLb = function () {
      lb.hidden = true;
      lbImg.src = 'data:,';
      document.documentElement.style.overflow = '';
      if (lbBack) lbBack.focus({ preventScroll: true });
    };
    var stepLb = function (d) {
      if (lbList.length < 2) return;
      lbIdx = (lbIdx + d + lbList.length) % lbList.length;
      showLb();
    };
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.cl2 [data-cl2-img]');
      if (b) openLb(b);
    });
    var galZoom = root.querySelector('[data-cl2-galzoom]');
    if (galZoom) galZoom.addEventListener('click', function () {
      var track = root.querySelector('.cl2-gal__track');
      var items = track.querySelectorAll('[data-cl2-img]');
      var w = track.children[0] ? track.children[0].getBoundingClientRect().width : 1;
      var i = Math.min(items.length - 1, Math.round(track.scrollLeft / (w + 10)));
      if (items[i]) openLb(items[i]);
    });
    lbPrev.addEventListener('click', function () { stepLb(-1); });
    lbNext.addEventListener('click', function () { stepLb(1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('[data-cl2-lbclose]')) closeLb();
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') stepLb(-1);
      else if (e.key === 'ArrowRight') stepLb(1);
    });
    var tx = null;
    lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx;
      tx = null;
      if (Math.abs(dx) > 45) stepLb(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ── contadores: sobem de 0 quando entram na tela (o HTML já vem com o número final) ── */
  var nums = document.querySelectorAll('.cl2 [data-cl2-count]');
  if (nums.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, end = +el.dataset.cl2Count, t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 1100);
          el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))) + '%';
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }
})();
